import type { SelectOption } from '@petseo/shared';

export const RESERVATION_STATE = {
  PENDING: 'Pending',
  CONFIRMED: 'Confirmed',
  CANCELLED: 'Cancelled',
  REJECTED: 'Rejected',
  NO_SHOW: 'NoShow',
  COMPLETED: 'Completed',
} as const;

export type ReservationStateValue = (typeof RESERVATION_STATE)[keyof typeof RESERVATION_STATE];

export const RESERVATION_STATE_CONFIG: Record<string, { bg: string; text: string; label: string; border: string }> = {
  Pending: { bg: 'bg-warning-lt', text: 'text-warning', label: 'Oczekująca', border: 'border-warning' },
  Confirmed: { bg: 'bg-success-lt', text: 'text-success', label: 'Potwierdzona', border: 'border-success' },
  Cancelled: { bg: 'bg-secondary-lt', text: 'text-secondary', label: 'Anulowana', border: 'border-secondary' },
  Rejected: { bg: 'bg-danger-lt', text: 'text-danger', label: 'Odrzucona', border: 'border-danger' },
  NoShow: { bg: 'bg-orange-lt', text: 'text-orange', label: 'Nieobecność', border: 'border-orange' },
  Completed: { bg: 'bg-blue-lt', text: 'text-blue', label: 'Zakończona', border: 'border-blue' },
  External: { bg: 'bg-purple-lt', text: 'text-purple', label: 'Zewnętrzna', border: 'border-purple' },
};

export type ReservationAction = 'confirm' | 'reject' | 'noshow';

export const getAvailableActions = (state: string): ReservationAction[] => {
  switch (state) {
    case RESERVATION_STATE.PENDING:
      return ['confirm', 'reject'];
    case RESERVATION_STATE.CONFIRMED:
      return ['reject', 'noshow'];
    default:
      return [];
  }
};

export const RESERVATION_TYPE = {
  INTERNAL: 'Internal',
  EXTERNAL: 'External',
} as const;

export type ReservationTypeValue = (typeof RESERVATION_TYPE)[keyof typeof RESERVATION_TYPE];

export type ReservationTab = 'internal' | 'external';

export const RESERVATION_STATE_OPTIONS: SelectOption<ReservationStateValue | ''>[] = [
  { value: '', label: 'Wszystkie statusy' },
  { value: RESERVATION_STATE.CONFIRMED, label: 'Potwierdzona' },
  { value: RESERVATION_STATE.CANCELLED, label: 'Anulowana' },
  { value: RESERVATION_STATE.REJECTED, label: 'Odrzucona' },
  { value: RESERVATION_STATE.NO_SHOW, label: 'Nieobecność' },
  { value: RESERVATION_STATE.COMPLETED, label: 'Zakończona' },
];
